import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../constants/defaults';
import { changeMapLoaded, changeMapZoom } from '../actions';
import _ from 'lodash';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import * as turf from '@turf/turf'

const Fragment = React.Fragment;

const MapDiv = styled.div`
  width: 100%;
  height: 500px;
  border:1px solid #eee;
`;


class PoiMapContainer extends Component {
  constructor(props){
    super(props);

  }
  componentDidMount() {
    window.mapboxgl.accessToken = "pk.eyJ1IjoiZGF0YXBsdXNmZW1pbmlzbSIsImEiOiJjazl6aHc4cjQwNnRwM2xwZHJxZ2F4dm9vIn0.T9pZe5G7wOLEFLwdDlGBdg";//process.env.MAPBOX_TOKEN;

    this.map = new window.mapboxgl.Map({
      container: this.refsMapContainer,
      style: 'mapbox://styles/dataplusfeminism/ckd56g7q00bkm1imrngrva4uh',
      zoom: 3,
      minZoom: 3,
      center: [ -90, 40],
      // interactive: false
    });


    window.map = this.map;
    this.map.on('style.load', this.handleStyleLoad.bind(this));
  
  }

  async handleStyleLoad() {
    var centroid = turf.centroid(this.props.geojson);
    
    this.map.addSource('poi', {
      type: 'geojson',
      data: this.props.geojson
    });

    this.map.addLayer({
      'id': 'poi_layer',
      'type': 'circle',
      'source': 'poi',
      'layout': {},
      'paint': {
        'circle-color': '#000000',
        'circle-opacity': 1,
        'circle-radius': 10
      }
    });

    this.map.jumpTo({
      center: centroid.geometry.coordinates,
      zoom: 17
    });
  }

  

  render() {
    return (
      <MapDiv ref={c => { this.refsMapContainer = c; }}>
      </MapDiv>
    );
  }
}

let mapStateToProps = state => {

  return {
    windowWidth: state.windowWidth,
    windowHeight: state.windowHeight
  }
}

export default withRouter(connect(mapStateToProps)(PoiMapContainer));